import { styled } from '@teko/ui';
import React from 'react';
import { DiscoveryBlock } from 'types';

export interface LeftRightStickyBannerBlockProps {
  leftBlock?: DiscoveryBlock;
  rightBlock?: DiscoveryBlock;
  stickyTop?: number;
}

interface BannerProps {
  width?: number;
  height?: number;
}

interface StickyBannerImgProps extends BannerProps {
  url?: string;
  image?: string;
}

const StickyBannerImg: React.FC<StickyBannerImgProps> = ({
  width,
  height,
  url,
  image,
}: StickyBannerImgProps) => {
  return (
    <Banner width={width} height={height}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <StyledImg src={image} />
      </a>
    </Banner>
  );
};

export const LeftRightStickyBannerBlock: React.FC<LeftRightStickyBannerBlockProps> =
  ({
    leftBlock,
    rightBlock,
    stickyTop = 72,
  }: LeftRightStickyBannerBlockProps) => {
    const leftBanners = leftBlock?.cookedData;
    const rightBanners = rightBlock?.cookedData;
    return (
      <StickyWrapper stickyTop={stickyTop}>
        <Wrapper>
          <BannerListLeft>
            {leftBanners?.map((banner) => (
              <React.Fragment key={banner.id}>
                {banner && (
                  <StickyBannerImg
                    width={banner.imageSize?.width}
                    height={banner.imageSize?.height}
                    url={banner.url}
                    image={banner.image}
                  />
                )}
              </React.Fragment>
            ))}
          </BannerListLeft>
          <Middle></Middle>
          <BannerListRight>
            {rightBanners?.map((banner) => (
              <React.Fragment key={banner.id}>
                {banner && (
                  <StickyBannerImg
                    width={banner.imageSize?.width}
                    height={banner.imageSize?.height}
                    url={banner.url}
                    image={banner.image}
                  />
                )}
              </React.Fragment>
            ))}
          </BannerListRight>
        </Wrapper>
      </StickyWrapper>
    );
  };

const StickyWrapper = styled.div<{ stickyTop?: number }>(
  ({ stickyTop }) => `
    position: sticky;
    top: ${stickyTop}px;
    display: flex;
    justify-content: center;
`,
);

const Wrapper = styled.div`
  position: absolute;
  margin-top: 24px;
`;

const Banner = styled.div<BannerProps>(
  ({ width, height }) => `
    margin-bottom: 16px;
    width: ${width || 150}px;
    height: ${height || 350}px;
`,
);

const BannerListLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  right: 100%;
`;

const BannerListRight = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 100%;
`;

const Middle = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 1264px;
  z-index: -1;
`;

const StyledImg = styled.img`
  cursor: pointer;
  object-fit: fill;
  width: 100%;
  height: 100%;
  transition: transform 0.4s;
  &:hover {
    transform: scale(1.05);
  }
`;
